/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import React from "react"
import {
    LOW_DEMAND_MODE,
    PROVEN_IN_USE, PROVEN_NO,
    TYPE_A, TYPE_B,
} from "const"
import { ProvenType, SilMode, SilType } from "client/utils"
import { LangType } from "client/store"
import { InsufficientData, NotCompliant } from "client/components"

interface SilWrapperProps {
    data: string
}
const SilWrapper = ({ data }: SilWrapperProps) => (
    <span>
        {data}
        <sub>H</sub>
    </span>
)

interface Iec_61508_2010 {
    type: SilType
    mode: SilMode
    provenInUse: ProvenType
    sff: string | number | boolean
    dc: string | number | boolean
    lang: LangType
    silOnly?: boolean
    textError?: boolean
}
export const iec_61508_2010_device = (props: Iec_61508_2010) => {
    const { type, mode, provenInUse, lang, silOnly, textError } = props
    const sff = typeof props.sff === "string" ? parseFloat(props.sff) : props.sff
    const dc = typeof props.dc === "string" ? parseFloat(props.dc) : props.dc

    if (provenInUse === PROVEN_NO) { // this is route 1h
        if (sff === false || sff === null) return textError ? lang.insufficientData : <InsufficientData />

        if (type === TYPE_A) {
            if (sff < 0.6) return silOnly ? lang.sil_1 : <SilWrapper data={lang.sil_1_1} />
            if (sff >= 0.6 && sff < 0.9) return silOnly ? lang.sil_2 : <SilWrapper data={lang.sil_2_1} />
            if (sff >= 0.9) return silOnly ? lang.sil_3 : <SilWrapper data={lang.sil_3_1} />
            return textError ? lang.insufficientData : <InsufficientData />
        }
        if (type === TYPE_B) {
            if (sff < 0.6) return textError ? lang.notCompliant : <NotCompliant />
            if (sff >= 0.6 && sff < 0.9) return silOnly ? lang.sil_1 : <SilWrapper data={lang.sil_1_1} />
            if (sff >= 0.9 && sff < 0.99) return silOnly ? lang.sil_2 : <SilWrapper data={lang.sil_2_1} />
            if (sff >= 0.99) return silOnly ? lang.sil_3 : <SilWrapper data={lang.sil_3_1} />
            return textError ? lang.insufficientData : <InsufficientData />
        }
        return textError ? lang.insufficientData : <InsufficientData />
    }

    if (provenInUse === PROVEN_IN_USE) { // this is route 2h
        if (dc === false || dc === null) return textError ? lang.insufficientData : <InsufficientData />

        if (type === TYPE_B && dc < 0.6) return textError ? lang.notCompliant : <NotCompliant />

        if (mode === LOW_DEMAND_MODE) return silOnly ? lang.sil_2 : <SilWrapper data={lang.sil_2_2} />
        return silOnly ? lang.sil_1 : <SilWrapper data={lang.sil_1_2} />
    }
    return textError ? lang.insufficientData : <InsufficientData />
}
